export default __webpack_public_path__ + "2c41512434a62d54e4fd2537d15b1ce6.svg";